// Centralized WhatsApp contact helper for Santa Mónica Residencial.
// All wa.me URLs and pre-filled messages should be built through this module
// so the number can be updated in a single place (REACT_APP_WHATSAPP).
import { trackEvent as metaTrack, getBrowserSignals } from './metaTrack';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP || '525567911796';
export const PHONE_NUMBER = process.env.REACT_APP_PHONE || '+525567911796';

/**
 * Build a wa.me URL with an optional pre-filled message.
 * @param {string} [text] Plain (un-encoded) message text.
 * @returns {string} Full https://wa.me/<number>?text=<encoded> URL.
 */
export function waLink(text) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  if (!text) return base;
  return `${base}?text=${encodeURIComponent(text)}`;
}

/** Default brand-aware message for generic CTAs. */
export const DEFAULT_WA_MESSAGE =
  'Me interesa más información de Santa Mónica Residencial';

/**
 * Relay a Contact event to the server-side Conversions API using the SAME
 * event_id as the browser Pixel so Meta can deduplicate the two signals.
 * Fire-and-forget: errors never block the user action.
 */
function sendServerContact(eventId, contentName, source) {
  if (!API_BASE || !eventId) return;
  try {
    const signals = getBrowserSignals(eventId);
    fetch(`${API_BASE}/api/meta/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // keepalive = survive the navigation to wa.me / tel:
      keepalive: true,
      body: JSON.stringify({
        event_name: 'Contact',
        event_id: signals.event_id,
        event_source_url: signals.event_source_url,
        fbp: signals.fbp,
        fbc: signals.fbc,
        custom_data: {
          content_name: contentName,
          content_category: contentName.toLowerCase(),
          source,
        },
      }),
    }).catch(() => { /* swallow network errors */ });
  } catch { /* ignore */ }
}

/**
 * Fire Meta Pixel + Conversions API Contact event for WhatsApp interactions.
 * Call this in the onClick of any <a href="wa.me/..."> or button that opens WhatsApp.
 */
export function trackWhatsAppContact(source = 'generic') {
  const eventId = metaTrack('Contact', {
    content_name: 'WhatsApp',
    content_category: 'whatsapp',
    source,
  });
  sendServerContact(eventId, 'WhatsApp', source);
  return eventId;
}

/**
 * Fire Meta Pixel + Conversions API Contact event for phone-call interactions.
 * Call this in the onClick of any <a href="tel:..."> link.
 */
export function trackPhoneContact(source = 'generic') {
  const eventId = metaTrack('Contact', {
    content_name: 'Phone',
    content_category: 'phone',
    source,
  });
  sendServerContact(eventId, 'Phone', source);
  return eventId;
}
